import { Button, Space } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import { Link, Outlet } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import { PlusCircle } from "lucide-react";
import ProjectExplanation from "../../components/explanations/ProjectExplanation";
import ExplanationButton from "../../components/explanations/ExplanationButton";

const Projects = () => {
    return (
        <PageContentWrapper
            size="large"
            header={
                <PageHeader
                    title={
                        <>
                            Projects
                            <ExplanationButton
                                content={<ProjectExplanation />}
                            />
                        </>
                    }
                    extra={
                        <Button>
                            <Link to="/pricing/new">
                                <Space>
                                    <PlusCircle size={16} />
                                    Create Project
                                </Space>
                            </Link>
                        </Button>
                    }
                />
            }
        >
            <Outlet />
        </PageContentWrapper >
    )
}


export default Projects;